import axios from "axios";
import mentoriaApi from "./axiosTokenMiddleware";

const mentoriaURL = process.env.REACT_APP_MENTORIA_FINANCIERA_URL || "";
const mentoriaApiKey = process.env.REACT_APP_MENTORIA_FINANCIERA_API_KEY || "";


export const getQuestionsByPurposes = async (purposes: any) => {
	return mentoriaApi.post(mentoriaURL + "getQuestionsByPurpose", purposes, {
		headers: {
			"Content-Type": "application/json;charset=UTF-8",
			ApiKey: mentoriaApiKey
		},
	});
};

export const postResponsesPurposes = async (payload: any) => {
	return mentoriaApi.post(mentoriaURL + "saveQuestionsByPurposes", payload, {
		headers: {
			"Content-Type": "application/json",
			ApiKey: mentoriaApiKey
		},
	});
};

export const getDiagnosticQuestions = async () => {
	return mentoriaApi.get(mentoriaURL + "getDiagnosticQuestionsFinal", {
		headers: {
			"Content-Type": "application/json",
			ApiKey: mentoriaApiKey
		},
	});
};

export const getDiagnosticQuestionsCac = async () => {
	return mentoriaApi.get(mentoriaURL + "getDiagnosticQuestionsCac", {
		headers: {
			"Content-Type": "application/json",
			ApiKey: mentoriaApiKey
		},
	});
};

export const getResults = async () => {
	return mentoriaApi.get(mentoriaURL + "getDiagnosticResult", {
		headers: {
			"Content-Type": "application/json",
			ApiKey: mentoriaApiKey
		},
	});
};

export const getInitialResults = async () => {
	return mentoriaApi.get(mentoriaURL + "getInitialDiagnosticResult", {
		headers: {
			"Content-Type": "application/json",
			ApiKey: mentoriaApiKey
		},
	});
};

export const postResponsesDiagnostic = async (payload: any) => {
	return mentoriaApi.post(mentoriaURL + "saveResponses", payload, {
		headers: {
			"Content-Type": "application/json",
			ApiKey: mentoriaApiKey
		},
	});
};

export const postSendOtp = async (payload: any) => {
	return mentoriaApi.post(mentoriaURL + "sendOtp", payload, {
		headers: {
			"Content-Type": "application/json",
			ApiKey: mentoriaApiKey,
		},
	});
};

export const postValidateOtp = async ( payload: any) => {
	return mentoriaApi.post(mentoriaURL + "validateOtp", payload, {
		headers: {
			"Content-Type": "application/json",
			ApiKey: mentoriaApiKey
		},
	});
};

export const acceptCAC = async () => {
	return mentoriaApi.post(mentoriaURL + "wayToMyHouse",{toAccept: true,},{
			headers: {
				"Content-Type": "application/json",
				ApiKey: mentoriaApiKey
			},
		},
	);
};

export const getDataTreatment = () => {
	return mentoriaApi.get(mentoriaURL + "hasDataTreatment", {
		headers: {
			"Content-Type": "application/json",
			ApiKey: mentoriaApiKey
		},
	});
};

export const getCurrentStateByUser = () => {
	return mentoriaApi.get(mentoriaURL + "getCurrentStateByUser", {
		headers: {
			"Content-Type": "application/json",
			ApiKey: mentoriaApiKey
		},
	});
};
